/** Env var: tenant key (e.g. "jimssoft", "ipasoft"). Unset → default (Exacc orange). */
export const WHITE_LABEL_ENV_KEY = "REACT_APP_WHITE_LABEL";

export const JIMSSOFT = "jimssoft";
export const IPASOFT = "ipasoft";

const WHITE_LABEL_LOGOS = {
  [JIMSSOFT]: "jims-tax-logo.png",
  [IPASOFT]: "ipa-logo.png",
};

/** Compensates for extra padding inside the logo PNG (multiplier on max-height). */
const WHITE_LABEL_LOGO_HEIGHT_SCALE = {
  [IPASOFT]: 2,
};

/** Legacy alias — exx-blue deployments should migrate to REACT_APP_WHITE_LABEL=jimssoft */
const LEGACY_ALIASES = {
  "exx-blue": JIMSSOFT,
};

const publicBase = (process.env.PUBLIC_URL || "").replace(/\/$/, "");

/** Active white-label key from REACT_APP_WHITE_LABEL (defaults to "default"). */
export function getWhiteLabelKey() {
  // Must use literal process.env.REACT_APP_* — CRA/webpack only inlines static keys.
  const fromEnv = process.env.REACT_APP_WHITE_LABEL?.trim();
  if (!fromEnv) {
    return "default";
  }
  return LEGACY_ALIASES[fromEnv] ?? fromEnv;
}

export function isJimssoftWhiteLabel() {
  return getWhiteLabelKey() === JIMSSOFT;
}

export function isIpasoftWhiteLabel() {
  return getWhiteLabelKey() === IPASOFT;
}

export function isWhiteLabelTenant() {
  return getWhiteLabelKey() !== "default";
}

export function getWhiteLabelLogoUrl() {
  const fileName = WHITE_LABEL_LOGOS[getWhiteLabelKey()];
  if (!fileName) {
    return null;
  }
  return `${publicBase}/${fileName}`;
}

export function getWhiteLabelLogoHeightScale() {
  return WHITE_LABEL_LOGO_HEIGHT_SCALE[getWhiteLabelKey()] ?? 1;
}

export function usesCustomLogo() {
  return Boolean(WHITE_LABEL_LOGOS[getWhiteLabelKey()]);
}

export function usesJimssoftHero() {
  return isJimssoftWhiteLabel();
}

/** Left auth panel uses tenant-specific imagery instead of default Exacc hero. */
export function usesCustomLeftVisual() {
  return isJimssoftWhiteLabel() || isIpasoftWhiteLabel();
}
